module.exports = __webpack_public_path__ + "static/media/6115095.1b742363.jpg";